import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody } from "reactstrap";

const UnsubscribeModal = ({ show, onUnsubscribeClick, onCloseClick }) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <lord-icon
            src="https://cdn.lordicon.com/gsqxdxog.json"
            trigger="loop"
            colors="primary:#f7b84b,secondary:#f06548"
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>

          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Unsubscribe Email?</h4>
            <p className="text-muted mx-4 mb-0">
              Are you sure you want to unsubscribe this email from the newsletter?
            </p>
          </div>
        </div>

        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            onClick={onCloseClick}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn w-sm btn-danger"
            onClick={onUnsubscribeClick}
          >
            Yes, Unsubscribe
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

UnsubscribeModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  onUnsubscribeClick: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

export default UnsubscribeModal;
